import React, { useEffect, useState } from "react";
import { UserAuth } from "../Context";
import { doc, updateDoc, getDoc } from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { Link } from "react-router-dom";
import { Button, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import {
  deleteShoppingListFromAlgolia,
  saveShoppingListToAlgolia,
} from "../lib/algoliaFunctions";
function Settings({ selectedShopList, BackgroundOnSvg, closeOtherDropdown }) {
  const { user } = UserAuth();
  const visibilityLevels = ["Public", "Friends", "Private"];
  const visibilityOptions = {
    Public: "(Anyone can view and comment)",
    Friends: "(Invited Friends according to roles)",
    Private: "(Only You can perform actions)",
  };
  const [visibility, setVisibility] = useState(visibilityLevels[0] || "");
  const [show, setShow] = useState(false);
  console.log("visibility is ", visibility);
  console.log("selectedShopList1 is ", selectedShopList);

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleClose = () => {
    setShow(false);
  };
  const fetchVisibility = async () => {
    if (!user || !selectedShopList) return;

    // Reference to the shoppingList subcollection document
    const shoppingListDocRef = doc(
      db,
      "users",
      user?.uid,
      "shoppingList",
      selectedShopList
    );
    const shoppingListDocSnap = await getDoc(shoppingListDocRef);

    if (!shoppingListDocSnap.exists()) {
      console.log("No such document in shoppingList subcollection!");
      return; // Early return if shopping list document does not exist
    }

    // Extract visibility from the shopping list document
    const visibilityFromDB =
      shoppingListDocSnap?.data()?.visibility || visibilityLevels[0];
    setVisibility(visibilityFromDB);
  };

  useEffect(() => {
    fetchVisibility();
    // eslint-disable-next-line
  }, [selectedShopList, user]);

  const handleClick = async () => {
    try {
      // Reference to the specific document in the shoppingList subcollection
      const shoppingListDocRef = doc(
        db,
        "users",
        user?.uid,
        "shoppingList",
        selectedShopList
      );

      // Read the document
      const docSnap = await getDoc(shoppingListDocRef);

      if (!docSnap.exists()) {
        console.log("No such document!");
      } else {
        if (visibility === "Public") {
          console.log("saving list to algolia");
          saveShoppingListToAlgolia(user, docSnap?.id);
        } else {
          console.log("deleting list from algolia");
          deleteShoppingListFromAlgolia(docSnap?.data()?.listId);
        }
        // Update the visibility property within the specific document
        await updateDoc(shoppingListDocRef, {
          visibility: visibility, // Set the visibility to the desired value
        });
        toast.success(`Settings has been updated`, toastOptions);
        console.log("Document successfully updated with new visibility!");
      }
      handleClose();
    } catch (error) {
      console.error("Error updating visibility: ", error);
    }
  };

  return (
    <>
      <div
        className="d-flex align-items-center"
        style={{ gap: "12px" }}
        onClick={() => {
          setShow(true);
          closeOtherDropdown();
        }}
      >
        <BackgroundOnSvg>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.8125 15.0521C14.734 16.2928 13.2871 17.1561 11.6832 17.5161C10.0792 17.8761 8.40215 17.7139 6.89691 17.0532C5.39167 16.3923 4.13713 15.2675 3.31649 13.8431C2.49586 12.4186 2.15211 10.7691 2.33545 9.13546C2.51864 7.50165 3.21941 5.96919 4.33541 4.76193C5.4514 3.55467 6.92416 2.73585 8.53857 2.42505M11.4584 2.4313C12.5425 2.64009 13.5691 3.07933 14.4688 3.71929C15.3684 4.35925 16.1201 5.18501 16.6729 6.14067C17.2258 7.09635 17.567 8.15965 17.6733 9.25861C17.7796 10.3576 17.6486 11.4665 17.2891 12.5105"
              stroke="#676A79"
              stroke-linecap="round"
            />
            <path
              d="M8.33337 9.58337V8.09379C8.33337 7.19056 9.07952 6.45837 10 6.45837C10.9206 6.45837 11.6667 7.19056 11.6667 8.09379V9.58337M7.91671 9.58337H12.0834C12.545 9.58337 12.9167 9.95504 12.9167 10.4167V12.7084C12.9167 13.17 12.545 13.5417 12.0834 13.5417H7.91671C7.45504 13.5417 7.08337 13.17 7.08337 12.7084V10.4167C7.08337 9.95504 7.45504 9.58337 7.91671 9.58337Z"
              stroke="#676A79"
            />
          </svg>
        </BackgroundOnSvg>

        <span
          style={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "100%",
            letterSpacing: "0px",
          }}
        >
          Privacy Controls
        </span>
      </div>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body style={{ padding: isSmallScreen ? "1rem" : "2rem" }}>
          <div className="d-flex flex-column mb-4 gap-4">
            <div className="d-flex w-100 justify-content-between">
              <div className="h4">Edit List Privacy Control</div>
              <button
                type="button"
                style={{
                  boxSizing: "border-box",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "27px",
                  height: "27px",
                  background: "#FFFFFF",
                  border: "1px solid #FF3B30",
                  boxShadow: "1px 1px 5px rgba(30, 30, 30, 0.14)",
                  borderRadius: "25px",
                  flex: "none",
                  order: "1",
                  flexGrow: "0",
                }}
                onClick={handleClose}
              >
                <svg
                  style={{ width: "11px" }}
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13 1L1 13M1 1L13 13"
                    stroke="#FF3B30"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
            <Form onClick={(e) => e.stopPropagation()}>
              {Object.entries(visibilityOptions).map(([level, label]) => (
                <div key={level} className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={level}
                    name="visibility"
                    value={level}
                    checked={visibility === level}
                    onChange={(e) => setVisibility(e.target.value)}
                  />
                  <label className="form-check-label" htmlFor={level}>
                    <span className="h6 grey mb-0">{level}</span> {label}
                  </label>
                </div>
              ))}
            </Form>
          </div>
          <div className="d-flex flex-column gap-2 w-100">
            <Button
              className="rounded-3"
              variant="primary"
              onClick={async () => {
                handleClick();
                handleClose();
              }}
            >
              Done
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {/* <!-- Modal create events END --> */}
    </>
  );
}

export default Settings;
